import React, { useEffect, useRef, useState } from "react";
import SVG from "react-inlinesvg";

const ShortsSection = ({ youtubeShorts }) => {
  const playersRef = useRef([]);
  const [apiReady, setApiReady] = useState(false);

  // Load YouTube IFrame API
  useEffect(() => {
    if (window.YT && window.YT.Player) {
      setApiReady(true);
    } else {
      const tag = document.createElement("script");
      tag.src = "https://www.youtube.com/iframe_api";
      document.body.appendChild(tag);
      window.onYouTubeIframeAPIReady = () => setApiReady(true);
    }
  }, []);

  // Initialize YouTube players
  useEffect(() => {
    if (!apiReady) return;

    youtubeShorts?.forEach((short, index) => {
      const playerId = `youtube-player-${index}`;
      if (!document.getElementById(playerId)) return;

      playersRef.current[index] = new window.YT.Player(playerId, {
        videoId: short.videoId,
        playerVars: {
          playsinline: 1,
        },
        events: {
          onStateChange: (event) => {
            if (event.data === window.YT.PlayerState.PLAYING) {
              pauseAllExcept(index);
            }
          },
        },
      });
    });
  }, [apiReady]);

  const pauseAllExcept = (activeIndex) => {
    playersRef.current.forEach((player, i) => {
      if (i !== activeIndex && player?.pauseVideo) {
        player.pauseVideo();
      }
    });
  };

  // Pause when scrolled out of view
  useEffect(() => {
    if (!apiReady) return;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) {
            const index = Number(entry.target.dataset.index);
            const player = playersRef.current[index];
            if (player?.pauseVideo) {
              player.pauseVideo();
            }
          }
        });
      },
      { threshold: 0.5 }
    );

    youtubeShorts.forEach((_, index) => {
      const el = document.getElementById(`short-container-${index}`);
      if (el) observer.observe(el);
    });

    return () => observer.disconnect();
  }, [apiReady]);
  const scrollContainer = (scrollOffset) => {
    const container = document.querySelector(".shorts-container");
    if (container) {
      container.scrollBy({
        left: scrollOffset,
        behavior: "smooth",
      });
    }
  };

  return (
    <div className="bg-white p-4">
      <h2 className="flex items-center text-lg font-semibold mb-4">
        <SVG
          src="https://akm-img-a-in.tosshub.com/lingo/newstak/resources/prod/video-clip.svg"
          className="h-6 w-6 mr-2"
          title="webstories"
        />
        शॉर्ट्स
      </h2>

      <div className="relative">
        {/* Left Button */}
        {youtubeShorts?.length > 2 && (
          <button
            onClick={() => scrollContainer(-300)}
            className="absolute left-0 top-1/2 transform -translate-y-1/2 bg-gray-200 rounded-full p-2 shadow z-10"
          >
            <SVG src="https://akm-img-a-in.tosshub.com/lingo/newstak/resources/prod/chevron-left.svg" className="w-4 h-4" />
          </button>
        )}

        {/* Shorts Container */}
        <div
          className="shorts-container flex flex-nowrap gap-4 justify-start overflow-x-auto scrollbar-hide scroll-smooth"
          style={{ scrollBehavior: "smooth" }}
        >
          {youtubeShorts &&
            youtubeShorts.map((short, index) => (
              <div
                key={short.id}
                id={`short-container-${index}`}
                data-index={index}
                className="min-w-[220px] bg-white rounded-xl shadow-md border-2 border-black overflow-hidden"
              >
                <div className="relative w-full h-[420px]">
                  <div
                    id={`youtube-player-${index}`}
                    className="w-full h-full"
                  ></div>
                </div>
              </div>
            ))}
        </div>

        {/* Right Button */}
        {youtubeShorts?.length > 2 && <button
          onClick={() => scrollContainer(300)}
          className="absolute right-0 top-1/2 transform -translate-y-1/2 bg-gray-200 rounded-full p-2 shadow z-10"
        >
          <SVG
            src="https://akm-img-a-in.tosshub.com/lingo/newstak/resources/prod/chevron-right.svg"
            className="w-4 h-4 stroke-2"
          />
        </button>}
      </div>
    </div>
  );
};

export default ShortsSection;
